import Vue from 'vue'
import Router from 'vue-router'
import ContractPortal from './views/ContractorPortal/ContractPortal'
import Dashboard from './views/Dashboard'
import ReturnsList from './views/ReturnsList'
import ReadReturn from './views/ReadReturn/ReadReturn'
import EditReturn from './views/EditReturn'
import NotFound from './views/NotFound'
import authGuard from './utils/guards/authGaurd'
import invoiceSearchGuard from './utils/guards/invoiceSearchGuard'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'contractPortal',
            component: ContractPortal
        },
        {
            path: '/dashboard',
            component: Dashboard,
            beforeEnter: authGuard,
            redirect: { name: 'returnsList' },
            children: [
                {
                    path: 'returns',
                    name: 'returnsList',
                    component: ReturnsList
                },
                {
                    path: 'returns/:id',
                    name: 'readReturn',
                    component: ReadReturn
                },
                {
                    path: 'returns/:id/edit',
                    name: 'editReturn',
                    component: EditReturn
                },
                {
                    path: 'invoice-search',
                    name: 'invoiceSearch',
                    beforeEnter: invoiceSearchGuard,
                    component: ContractPortal,
                    props: { toolbar: false }
                }
            ]
        },
        {
            path: '*',
            name: 'notFound',
            component: NotFound
        }
    ]
})
